import { createActions } from "redux-actions";
import { createRequestAction } from "../utils";

const partnersActions = {
  ...createActions({
    GET_PARTNERS: (from) => ({ from }),
    CURRENT_PARTNERS_PAGE: (page) => ({ page }),
    CREATE_PARTNER: (data) => ({ data }),
    UPDATE_PARTNER_STATUS: (partnerId, data) => ({ partnerId, data }),
  }),
  ...createRequestAction("GET_PARTNERS"),
  ...createRequestAction("CREATE_PARTNER"),
  ...createRequestAction("UPDATE_PARTNER_STATUS"),
  CURRENT_PARTNERS_PAGE: "CURRENT_PARTNERS_PAGE",
};

export default partnersActions;
